import util from "../util/Util";
import AbstractModel from "./AbstractModel";

export default class ContactModel extends AbstractModel {

    id;
    email;
    firstName;
    // lastName; ahora nombre y apellido van en firstName
    clientId;
    phoneNumber;
    mobileNumber;
    position;

    nameMainType = "contact";
    graphFindByIdOperation = "contact";
    graphFindOperation = "contactsConnection";

    getArrayFields() {
        let result = {
            "id": {type: "CodeField"},
            "email": "",
            "firstName": {label: "Nombre"},
            "clientId": "",
            // "lastName": "", ahora nombre y apellido van en firstName
            "phoneNumber": {label: "Télefono"},
            "mobileNumber": "",
            "position": "",

        };
        return result;
    }

    getFullName() {
        let result = "";
        if (util.hasValue(this.firstName)) {
            result += this.firstName + " ";
        }
        if (util.hasValue(this.lastName)) {
            result += this.lastName;
        }
        result = util.trim(result);
        return result;
    }

}
